import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
const variantMap = {
    blue: {
        backgroundColor: theme.blue.main,
    },
    green: {
        backgroundColor: theme.green.main,
    },
    greyLight: {
        backgroundColor: theme.transparentGrey.main,
    },
    greyMedium: {
        backgroundColor: theme.grey.darker,
    },
    navy: {
        backgroundColor: theme.navy.main,
    },
    orange: {
        backgroundColor: theme.orange.main,
    },
    orangeLight: {
        backgroundColor: theme.orange.lighter,
    },
    pink: {
        backgroundColor: theme.pink.main,
    },
    purple: {
        backgroundColor: theme.purple.main,
    },
    purpleLight: {
        backgroundColor: theme.purple.lighter,
    },
    red: {
        backgroundColor: theme.red.main,
    },
    transparentGrey: {
        backgroundColor: theme.transparentGrey.main,
    },
    white: {
        backgroundColor: theme.white.main,
    },
    yellow: {
        backgroundColor: theme.yellow.main,
    },
};
const cardStaticStyle = css({
    '&:where(a, button)': {
        cursor: 'pointer',
        userSelect: 'none',
    },
    backgroundColor: theme.background.contrast,
    borderColor: theme.border.main,
    borderRadius: tokens.borderRadius.medium,
    borderStyle: 'solid',
    borderWidth: tokens.borderWidth.thin,
    display: 'block',
    outline: 0,
    padding: tokens.spacingNew.medium,
    position: 'relative',
    textDecoration: 'none',
    transition: 'box-shadow 600ms cubic-bezier(0.1, 0.8, 0.2, 1), transform 600ms cubic-bezier(0.1, 0.8, 0.2, 1)',
});
export function cardStyle({ disableHoverEffect, hasHeadstone, inverted, isFocusVisible, }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        cardStaticStyle,
        ...(hasHeadstone ? [css({ paddingTop: '28px' })] : []),
        isFocusVisible
            ? css({
                boxShadow: `0 0 0 2px ${theme.border.focusOutline}`,
            })
            : css(Object.assign({}, (!disableHoverEffect && {
                '&:focus-within': {
                    boxShadow: theme.boxShadow.thick,
                    transform: 'translateY(-1px)',
                },
            }))),
        ...(!disableHoverEffect
            ? [
                css({
                    '&:hover': Object.assign({ boxShadow: theme.boxShadow.thick, transform: 'translateY(-1px)' }, (isFocusVisible &&
                        css({
                            boxShadow: `0 0 0 2px ${theme.border.focusOutline}, ${theme.boxShadow.thick}`,
                        }))),
                }),
            ]
            : []),
    ];
}
export const headstoneStaticStyle = css({
    display: 'flex',
    gap: tokens.spacingNew.xsmall,
    left: tokens.spacingNew.medium,
    position: 'absolute',
    top: '-20px',
    zIndex: tokens.zIndex.default,
});
export const headerHeadingStaticStyle = css({
    alignItems: 'center',
    display: 'flex',
    gap: tokens.spacingNew.xsmall,
});
const decorStaticStyle = css({
    bottom: '-1px',
    position: 'absolute',
    top: '-1px',
    width: '4px',
    zIndex: tokens.zIndex.default,
});
export function decorStyle({ highlightPlacement, highlightVariant, }) {
    return [
        decorStaticStyle,
        css({
            backgroundColor: variantMap[highlightVariant].backgroundColor,
        }),
        highlightPlacement === 'left'
            ? css({
                borderBottomLeftRadius: tokens.borderRadius.medium,
                borderTopLeftRadius: tokens.borderRadius.medium,
                left: '-1px',
            })
            : css({
                borderBottomRightRadius: tokens.borderRadius.medium,
                borderTopRightRadius: tokens.borderRadius.medium,
                right: '-1px',
            }),
    ];
}
export const bodyStaticStyle = css({
    color: theme.text.main,
    display: 'block',
    marginBottom: tokens.spacingNew.xsmall,
});
export const footerStaticStyle = css({
    alignItems: 'start',
    display: 'flex',
    flexShrink: 0,
    flexWrap: 'wrap',
    gap: tokens.spacingNew.xsmall,
});
